module.exports = __webpack_public_path__ + "img/wenzi.421c77b1.png";